/**
 * Subtle header USP rotator for #nav-top (fade + ~12px X).
 * Mobile: the Trustpilot nav item is the first slide. Desktop: it stays static on the left.
 * Rotation starts once the list gets .is-loaded (see trustpilot-fade.js).
 */
const DEFAULT_INTERVAL_MS = 3000;
const LEAVE_MS = 350;
const MOBILE_MQ = '(max-width: 760px)';

function getRotateItems(list) {
  const items = [...list.children].filter((el) => el.tagName === 'LI');
  const trustpilot = document.querySelector('#root #nav-top li.be-trustpilot-widget');
  if (trustpilot && window.matchMedia(MOBILE_MQ).matches) items.unshift(trustpilot);
  return items;
}

function startRotation(list, items) {
  if (items.length < 2 || list.dataset.beUspRotating === '1') return;
  list.dataset.beUspRotating = '1';

  const intervalMs =
    parseFloat(list.getAttribute('data-autoplay')) || DEFAULT_INTERVAL_MS;
  let index = 0;

  window.setInterval(() => {
    const leaving = items[index];
    leaving.classList.remove('is-active');
    leaving.classList.add('is-leaving');
    window.setTimeout(() => leaving.classList.remove('is-leaving'), LEAVE_MS);
    index = (index + 1) % items.length;
    items[index].classList.add('is-active');
  }, intervalMs);
}

export function initUspRotate() {
  const list = document.querySelector('#root #nav-top > ul.l4us.be-usp-rotate');
  if (!list) return;

  const items = getRotateItems(list);
  if (!items.length) return;

  items.forEach((el) => el.classList.remove('is-active'));
  items[0].classList.add('is-active');

  if (list.classList.contains('is-loaded')) {
    startRotation(list, items);
    return;
  }

  const observer = new MutationObserver(() => {
    if (list.classList.contains('is-loaded')) {
      observer.disconnect();
      startRotation(list, items);
    }
  });
  observer.observe(list, { attributes: true, attributeFilter: ['class'] });
}
